import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { VideoApiService, VideoEntity } from '../../../../core/services/video/video-api.service';
import { VideoPlayer } from '../../../../shared/components/video-player/video-player';

@Component({
  selector: 'app-movie-linked-videos',
  standalone: true,
  imports: [CommonModule, VideoPlayer],
  templateUrl: './movie-linked-videos.html',
  styleUrl: './movie-linked-videos.scss',
  host: {
    '[style.display]': '(!loading && videos.length === 0) ? "none" : "block"'
  }
})
export class MovieLinkedVideos implements OnInit, OnDestroy {
  private readonly subs = new Subscription();
  private movieId: number | null = null;

  videos: VideoEntity[] = [];
  loading = false;
  selectedVideo: VideoEntity | null = null;

  constructor(
    private readonly videoApi: VideoApiService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.route.paramMap.subscribe(params => {
        const slug = params.get('slug');
        if (slug) {
          const [id] = slug.split('-');
          const parsed = parseInt(id, 10);
          if (!isNaN(parsed)) {
            this.movieId = parsed;
            this.loadLinked();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadLinked(): void {
    if (!this.movieId) return;
    this.loading = true;
    this.subs.add(
      this.videoApi
        .listPublishedVideos({ page: 1, per_page: 8 })
        .subscribe({
          next: (res) => {
            const all = (res.results ?? []) as VideoEntity[];
            this.videos = all.filter((v) => v.linked_movie_id === this.movieId);
            this.loading = false;
          },
          error: () => {
            this.videos = [];
            this.loading = false;
          },
        }),
    );
  }

  selectVideo(video: VideoEntity): void {
    this.selectedVideo = this.selectedVideo?.id === video.id ? null : video;
  }

  text(value: unknown, fallback = ''): string {
    return typeof value === 'string' && value.trim().length > 0 ? value : fallback;
  }

  formatDuration(seconds: number | undefined): string {
    if (!seconds) return '--:--';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }
}
